module.exports = __webpack_public_path__ + "img/1A.85cf2100.jpg";